function lockLookupTable(windowRef) {
  switch (windowRef) {
    case 'nonXISInjections':
    case 'expressInjection':
    case 'standardInjection':
    case 'activateVials':
    case 'injectionAdjust':
      return 'injectionLock'
    case 'tracking':
    case 'trackingData':
      return 'trackingLock'
    case 'updatePatient':
      return 'patientDetailsLock'
    case 'vialMixing':
    case 'singleScreenMix':
      return 'mixingLock'
    default:
      return null
  }
}

export default lockLookupTable
